// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__WmLRX","indication":"styles_indication__SgHpR"};